import { ICompetition } from "./types";

export function getCompetitionName(competition: ICompetition) {
  return (competition.widgetCompetition?.shortName) ? competition.widgetCompetition.shortName : competition.trName
}

export function getFullCompetitionName(competition: ICompetition) {
  return competition.additionalName ?
    competition.region?.trName + ' - ' + competition.trName + ' - ' + competition.additionalName :
    competition.region?.trName + ' - ' + competition.trName;
}
